<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
      <FormItem label="获取数量" prop="applyCount">
        <InputNumber v-model="form.applyCount" :max="1000" :min="1"></InputNumber>
      </FormItem>
      <FormItem label="设备厂商" prop="brand">
        <sl-select dict="$$device_brand" value-type="string" v-model="form.brand" />
      </FormItem>
      <FormItem label="申请理由" prop="reason">
        <Input type="textarea" :autosize="{minRows: 5,maxRows: 8}" v-model="form.reason"></Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>
export default {
  data() {
    return {
      rules: {
        applyCount: [
          { type: 'number', required: true, message: '请输入获取数量', trigger: 'blur,change' },
        ],
        brand: [
          { required: false, message: '请选择设备厂商', trigger: 'blur,change' },
        ],
        reason: [
          { required: true, message: '请输入申请理由', trigger: 'blur,change' },
        ]
      },
      def: {},
      form: {
        applyCount: null,
        brand: null,
        reason: null,
      },
      id: null,
      loading: false,
      isCreate: true,
      modalVisible: false,
    }
  },

  computed: {
    itemTitle() {
      return this.id ? '编辑车辆号段' : '新增车辆号段'
    }
  },
  created() {
    this.def = { ...this.form }
  },

  methods: {

    init(id) {
      this.id = id
      this.reset()
      this.modalVisible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.$request.carNoSection(this.id).then(resp => {
        this.$utils.fill(this.form, resp.data)
      })

    },

    reset() {
      this.$utils.fill(this.form, this.def)
      this.$refs['form'].resetFields()
    },

    save() {
      //
      let params = { ...this.form }

      this.loading = true
      let promise = this.id ? this.$request.carNoSectionUpdate : this.$request.carNoSectionCreate
      promise(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')

          if (!this.id) {
            this.modalVisible = false
          }
        }
        this.loading = false
      })

    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleClose() {
      this.$emit('on-update')
    }
  }
}

</script>
